export const getValidationConfig = (fieldValidationConfig) => ({
    password: fieldValidationConfig.password
});
